import { LoaderCircle } from 'lucide-react';

import { cn } from '@platform/ui/lib/utils';

/** Progress with no known end. The circle is decorative; the label is what a screen reader hears. */
export function Spinner({ size = 'md', label, className }: { size?: 'sm' | 'md'; label?: string; className?: string }) {
    return (
        <>
            <LoaderCircle aria-hidden="true" className={cn('animate-spin', size === 'sm' ? 'size-3.5' : 'size-5', className)} />
            {label && <span className="sr-only">{label}</span>}
        </>
    );
}
